var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonationFeatureIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.997,
    height: 81,
    viewBox: "0 0 80.997 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3183",
    "data-name": "Rectangle 3183",
    width: 64.292,
    height: 66.589,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83197",
    "data-name": "Group 83197",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5586",
    "data-name": "Path 5586",
    d: "M40.5,0A40.5,40.5,0,1,1,0,40.5,40.5,40.5,0,0,1,40.5,0Z",
    transform: "translate(0 0)",
    fill: "#ffeaae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11571",
    "data-name": "Group 11571",
    transform: "translate(7.621 8.529)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3171",
    "data-name": "Rectangle 3171",
    width: 18.433,
    height: 46.082,
    transform: "translate(8.424 36.194) rotate(-78)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3172",
    "data-name": "Rectangle 3172",
    width: 18.433,
    height: 2.764,
    transform: "translate(50.794 45.2) rotate(-78)",
    fill: "#ffa92c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3173",
    "data-name": "Rectangle 3173",
    width: 18.433,
    height: 2.765,
    transform: "translate(8.423 36.194) rotate(-78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11570",
    "data-name": "Group 11570",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11569",
    "data-name": "Group 11569",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5484",
    "data-name": "Path 5484",
    d: "M52.826,46.635a.946.946,0,0,1-.192-.02L7.558,37.034a.921.921,0,0,1-.71-1.092L10.681,17.91a.923.923,0,0,1,1.093-.71l45.075,9.582a.923.923,0,0,1,.711,1.093l-3.832,18.03a.921.921,0,0,1-.9.729M8.844,35.423l43.271,9.2,3.45-16.227L12.293,19.2Z",
    transform: "translate(0.673 0.061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5485",
    "data-name": "Path 5485",
    d: "M46.436,41.413a.88.88,0,0,1-.192-.021l-9.015-1.916a.922.922,0,1,1,.384-1.8l8.267,1.758a2.782,2.782,0,0,1,2-1.3l1.215-5.717a2.782,2.782,0,0,1-1.3-2l-8.266-1.758a.922.922,0,1,1,.384-1.8l9.014,1.916a.923.923,0,0,1,.711,1.093.923.923,0,0,0,.71,1.093.921.921,0,0,1,.711,1.093l-1.534,7.212a.915.915,0,0,1-1.093.71.926.926,0,0,0-1.094.711.92.92,0,0,1-.9.729",
    transform: "translate(1.519 0.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5486",
    "data-name": "Path 5486",
    d: "M23.686,36.569a.88.88,0,0,1-.192-.021l-9.015-1.916a.922.922,0,0,1-.711-1.092.921.921,0,0,0-.709-1.093.923.923,0,0,1-.711-1.093l1.534-7.212a.92.92,0,0,1,1.093-.71.928.928,0,0,0,.693-.129.915.915,0,0,0,.4-.581.923.923,0,0,1,1.094-.711l9.014,1.916a.922.922,0,1,1-.383,1.8l-8.266-1.757a2.781,2.781,0,0,1-2,1.3L14.311,30.99a2.778,2.778,0,0,1,1.3,2l8.268,1.758a.921.921,0,0,1-.191,1.823",
    transform: "translate(0.83 0.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5487",
    "data-name": "Path 5487",
    d: "M31.307,38.093a4.749,4.749,0,0,1-.994-.1,5.135,5.135,0,0,1-3.474-2.733,7.02,7.02,0,0,1-.592-4.727c.738-3.478,3.762-5.8,6.75-5.161s4.807,3.98,4.068,7.461c-.657,3.093-3.123,5.265-5.758,5.265m.687-10.988c-1.778,0-3.471,1.579-3.944,3.807A5.173,5.173,0,0,0,28.47,34.4a3.322,3.322,0,0,0,2.227,1.79c1.983.421,4.036-1.255,4.565-3.741s-.66-4.852-2.648-5.274a3.015,3.015,0,0,0-.619-.065",
    transform: "translate(1.222 0.291)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3174",
    "data-name": "Rectangle 3174",
    width: 46.082,
    height: 18.433,
    transform: "translate(9.836 22.752)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3175",
    "data-name": "Rectangle 3175",
    width: 2.765,
    height: 18.433,
    transform: "translate(53.153 22.752)",
    fill: "#ffa92c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3176",
    "data-name": "Rectangle 3176",
    width: 2.765,
    height: 18.433,
    transform: "translate(9.836 22.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5488",
    "data-name": "Path 5488",
    d: "M55.207,41.919H9.124A.921.921,0,0,1,8.2,41V22.565a.921.921,0,0,1,.922-.922H55.207a.921.921,0,0,1,.922.922V41a.921.921,0,0,1-.922.922m-45.16-1.843H54.285V23.486H10.046Z",
    transform: "translate(0.712 0.188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5489",
    "data-name": "Path 5489",
    d: "M24.664,38.131H15.448a.921.921,0,0,1-.922-.922.923.923,0,0,0-.922-.922.921.921,0,0,1-.922-.922V27.993a.921.921,0,0,1,.922-.922.923.923,0,0,0,.922-.922.921.921,0,0,1,.922-.922h9.217a.922.922,0,0,1,0,1.843H16.212a2.779,2.779,0,0,1-1.686,1.686V34.6a2.779,2.779,0,0,1,1.686,1.686h8.452a.922.922,0,0,1,0,1.843",
    transform: "translate(0.84 0.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5490",
    "data-name": "Path 5490",
    d: "M47.911,38.131H38.695a.922.922,0,1,1,0-1.843h8.452A2.779,2.779,0,0,1,48.833,34.6V28.757a2.779,2.779,0,0,1-1.686-1.686H38.695a.922.922,0,1,1,0-1.843h9.217a.921.921,0,0,1,.922.922.923.923,0,0,0,.922.922.921.921,0,0,1,.922.922v7.373a.921.921,0,0,1-.922.922.923.923,0,0,0-.922.922.921.921,0,0,1-.922.922",
    transform: "translate(1.556 0.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5491",
    "data-name": "Path 5491",
    d: "M31.654,38.131c-3.05,0-5.53-2.894-5.53-6.452s2.481-6.451,5.53-6.451,5.53,2.894,5.53,6.451-2.481,6.452-5.53,6.452m0-11.06c-2.033,0-3.686,2.067-3.686,4.608s1.653,4.609,3.686,4.609,3.686-2.067,3.686-4.609-1.653-4.608-3.686-4.608",
    transform: "translate(1.223 0.29)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3177",
    "data-name": "Rectangle 3177",
    width: 46.082,
    height: 18.433,
    transform: "translate(8.423 27.744) rotate(-12)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3178",
    "data-name": "Rectangle 3178",
    width: 2.765,
    height: 18.433,
    transform: "translate(50.794 18.738) rotate(-12)",
    fill: "#ffa92c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3179",
    "data-name": "Rectangle 3179",
    width: 2.765,
    height: 18.433,
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 8.423, 27.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5492",
    "data-name": "Path 5492",
    d: "M11.583,46.635a.921.921,0,0,1-.9-.729L6.849,27.875a.921.921,0,0,1,.71-1.092L52.633,17.2a.923.923,0,0,1,1.094.71L57.56,35.94a.923.923,0,0,1-.711,1.093L11.774,46.615a.929.929,0,0,1-.191.02M8.844,28.393,12.293,44.62l43.272-9.2L52.115,19.2Z",
    transform: "translate(0.673 0.061)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5493",
    "data-name": "Path 5493",
    d: "M16.97,41.413a.921.921,0,0,1-.9-.73.91.91,0,0,0-.4-.581.924.924,0,0,0-.693-.129.919.919,0,0,1-1.093-.71l-1.534-7.212a.921.921,0,0,1,.711-1.093.922.922,0,0,0,.709-1.093.923.923,0,0,1,.711-1.093l9.015-1.916a.922.922,0,1,1,.383,1.8l-8.267,1.758a2.778,2.778,0,0,1-1.3,2l1.215,5.717a2.787,2.787,0,0,1,2,1.3l8.265-1.758a.922.922,0,1,1,.384,1.8l-9.015,1.916a.93.93,0,0,1-.191.021",
    transform: "translate(0.83 0.336)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5494",
    "data-name": "Path 5494",
    d: "M39.718,36.569a.921.921,0,0,1-.191-1.823l8.267-1.758a2.774,2.774,0,0,1,1.3-2l-1.216-5.717a2.783,2.783,0,0,1-2-1.3l-8.268,1.757a.922.922,0,1,1-.383-1.8l9.014-1.916a.922.922,0,0,1,1.093.71.929.929,0,0,0,1.094.711.917.917,0,0,1,1.093.71l1.533,7.212a.921.921,0,0,1-.71,1.093.921.921,0,0,0-.71,1.093.922.922,0,0,1-.711,1.092l-9.015,1.916a.88.88,0,0,1-.192.021",
    transform: "translate(1.519 0.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5495",
    "data-name": "Path 5495",
    d: "M31.987,38.095A5.288,5.288,0,0,1,28.711,36.9a7.261,7.261,0,0,1-1.872-8.8,5.137,5.137,0,0,1,3.474-2.734c2.979-.637,6.011,1.682,6.751,5.161a7.025,7.025,0,0,1-.593,4.727A5.138,5.138,0,0,1,33,37.988a4.815,4.815,0,0,1-1.01.107m-.671-10.99a3.015,3.015,0,0,0-.619.065,3.326,3.326,0,0,0-2.227,1.791,5.421,5.421,0,0,0,1.38,6.5A3.17,3.17,0,0,0,34.84,34.4a5.167,5.167,0,0,0,.421-3.484c-.473-2.228-2.167-3.807-3.944-3.807",
    transform: "translate(1.222 0.291)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3180",
    "data-name": "Rectangle 3180",
    width: 46.082,
    height: 18.433,
    transform: "translate(8.079 32.921) rotate(-23.999)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3181",
    "data-name": "Rectangle 3181",
    width: 2.765,
    height: 18.432,
    transform: "translate(47.652 15.302) rotate(-23.999)",
    fill: "#ffa92c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3182",
    "data-name": "Rectangle 3182",
    width: 2.765,
    height: 18.432,
    transform: "matrix(0.914, -0.407, 0.407, 0.914, 8.08, 32.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5496",
    "data-name": "Path 5496",
    d: "M22.074,47.358a.922.922,0,0,1-.376-1.764L55.376,30.6,48.628,15.444,44.42,17.318a.922.922,0,1,1-.751-1.684l5.051-2.249a.921.921,0,0,1,1.217.467l7.5,16.84a.921.921,0,0,1-.466,1.217L22.448,47.278a.916.916,0,0,1-.374.08",
    transform: "translate(1.082 -0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5497",
    "data-name": "Path 5497",
    d: "M14.915,50.586a.92.92,0,0,1-.842-.547L6.574,33.2a.922.922,0,0,1,.468-1.218l30.31-13.5a.922.922,0,0,1,.751,1.685L8.633,33.292,15.38,48.447l4.211-1.874a.921.921,0,0,1,.749,1.684l-5.052,2.249a.908.908,0,0,1-.373.08",
    transform: "translate(0.664 0.096)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5498",
    "data-name": "Path 5498",
    d: "M39.343,19.179a.921.921,0,0,1-.375-1.763l1.684-.75A.921.921,0,1,1,41.4,18.35l-1.684.749a.891.891,0,0,1-.373.08",
    transform: "translate(1.574 0.044)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5499",
    "data-name": "Path 5499",
    d: "M19.129,44.3a.92.92,0,0,1-.842-.547.922.922,0,0,0-1.217-.467.921.921,0,0,1-1.217-.467l-3-6.736a.921.921,0,0,1,.467-1.217.92.92,0,0,0,.466-1.217.923.923,0,0,1,.468-1.217l8.421-3.749a.921.921,0,0,1,.749,1.684L15.7,33.808a2.772,2.772,0,0,1-.855,2.227l2.377,5.339a2.78,2.78,0,0,1,2.227.854l7.722-3.436a.921.921,0,0,1,.749,1.684L19.5,44.223a.907.907,0,0,1-.373.08",
    transform: "translate(0.843 0.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5500",
    "data-name": "Path 5500",
    d: "M40.387,34.828a.922.922,0,0,1-.375-1.764l7.721-3.438a2.781,2.781,0,0,1,.855-2.225l-2.377-5.34a2.776,2.776,0,0,1-2.227-.855l-7.722,3.437a.921.921,0,0,1-.749-1.684l8.421-3.749a.921.921,0,0,1,1.217.468.92.92,0,0,0,1.216.467.927.927,0,0,1,.706-.019.915.915,0,0,1,.511.485l3,6.736a.922.922,0,0,1-.466,1.217.921.921,0,0,0-.467,1.217A.923.923,0,0,1,49.181,31l-8.421,3.749a.908.908,0,0,1-.373.08",
    transform: "translate(1.476 0.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5501",
    "data-name": "Path 5501",
    d: "M32.316,37.984a6.508,6.508,0,0,1-5.709-4.06,7.012,7.012,0,0,1-.4-4.747,5.008,5.008,0,0,1,7.247-3.228,7.019,7.019,0,0,1,3.258,3.476c1.447,3.249.358,6.9-2.426,8.143h0a4.824,4.824,0,0,1-1.967.415m1.592-1.257h0Zm-2.892-9.52a3.026,3.026,0,0,0-1.232.258,3.328,3.328,0,0,0-1.806,2.214,5.179,5.179,0,0,0,.312,3.495c1.034,2.321,3.386,3.538,5.243,2.711s2.527-3.389,1.493-5.71a5.172,5.172,0,0,0-2.388-2.57,3.684,3.684,0,0,0-1.622-.4",
    transform: "translate(1.219 0.294)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonationFeatureIcon);
export default __webpack_public_path__ + "static/media/donation_feature_icon.de866861e8d2079411f3f8ea4c55b5a3.svg";
export { ForwardRef as ReactComponent };